import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';
import Input from '@components/ui/Input';
import Button from '@components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@components/ui/Card';
import { Telescope, AlertCircle } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, isLoading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Bitte geben Sie E-Mail und Passwort ein.');
      return;
    }

    const success = await login(email, password);
    if (success) {
      navigate('/admin');
    } else {
      setError('Ungültige E-Mail-Adresse oder Passwort.');
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
              <Telescope className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="text-white font-bold text-xl">Sternwarte</h1>
              <p className="text-slate-400 text-sm">Mannheim</p>
            </div>
          </Link>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Admin Login</CardTitle>
            <CardDescription>
              Melden Sie sich an, um das Verwaltungspanel zu nutzen.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="flex items-center gap-2 p-3 rounded-lg bg-red-900/20 border border-red-800 text-red-400 text-sm">
                  <AlertCircle className="w-4 h-4 flex-shrink-0" />
                  <span>{error}</span>
                </div>
              )}

              <Input
                label="E-Mail-Adresse"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@sternwarte-mannheim.de"
                autoComplete="email"
                disabled={isLoading}
              />

              <Input
                label="Passwort"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                disabled={isLoading}
              />

              <Button 
                type="submit" 
                size="lg" 
                isLoading={isLoading}
                className="w-full"
              >
                Anmelden
              </Button>
            </form>

            <div className="mt-6 text-center">
              <Link 
                to="/" 
                className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
              >
                ← Zurück zur Website
              </Link>
            </div>
          </CardContent>
        </Card>

        <p className="mt-6 text-center text-slate-500 text-sm">
          Demo-Zugang: admin@sternwarte-mannheim.de / admin123
        </p>
      </div>
    </div>
  );
}
